import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PackageInitialState {
    packagesPage: number;
}

export const initialState: PackageInitialState = {
    packagesPage: 1,
};

export const slice = createSlice({
    name: "packages",
    initialState,
    reducers: {
        incrementPackagesPage: (state) => {
            state.packagesPage += 1;
        },
        resetPackagesPage: (state) => {
            state.packagesPage = 1;
        },
        setPackagesPage: (state, action: PayloadAction<number>) => {
            state.packagesPage = action.payload;
        },
    },
});

export const {
    incrementPackagesPage,
    resetPackagesPage,
    setPackagesPage,
} = slice.actions;

interface IState {
    packages: PackageInitialState;
}

export const packageSelector = (state: IState) => state.packages;

export default slice.reducer;